import { formatMinSec, minutesLevel, usedShare, wholeMinutes } from '@/shared/lib/minutes'
import { useMinutes } from '../model'
import css from './MinutesCard.module.css'

/**
 * «Использовано X из Y минут».
 *
 * Без пакета ничего не показываем: клиенту без ограничений счётчик ни к
 * чему, а «0 из 0» выглядело бы как поломка.
 */
export function MinutesCard() {
  const { data } = useMinutes()
  if (!data?.limited) return null

  const level = minutesLevel(data.usedMs, data.totalMinutes)
  const share = Math.min(1, usedShare(data.usedMs, data.totalMinutes))
  const used = wholeMinutes(data.usedMs).toLocaleString('ru-RU')
  const total = data.totalMinutes.toLocaleString('ru-RU')

  return (
    <section
      className={`${css.card} ${level === 'danger' ? css.danger : level === 'warn' ? css.warn : ''}`}
      aria-label="Пакет минут"
    >
      <div className={css.head}>
        <span className={css.title}>Пакет минут</span>
        <span className={css.value}>
          Использовано <strong>{used}</strong> из {total} мин
        </span>
      </div>
      <div
        className={css.bar}
        role="progressbar"
        aria-label="Израсходовано пакета"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={Math.round(share * 100)}
      >
        <span className={css.fill} style={{ width: `${share * 100}%` }} />
      </div>
      <p className={css.hint} role={level === 'ok' ? undefined : 'status'}>
        {data.exhausted
          ? 'Минуты закончились — новые звонки обзвона не начинаются. Чтобы продолжить, обратитесь к менеджеру.'
          : level === 'danger'
            ? `Осталось ${formatMinSec(data.leftMs)} — пакет почти исчерпан. Когда минуты кончатся, обзвон встанет на паузу.`
            : level === 'warn'
              ? `Осталось ${formatMinSec(data.leftMs)}. Израсходовано больше 80% пакета.`
              : `Осталось ${formatMinSec(data.leftMs)}. Считаем посекундно с момента ответа; недозвоны не списываются.`}
      </p>
    </section>
  )
}
